import { inject, Injectable, Injector } from '@angular/core';
import { handleRequestError } from '@softline/application';
import { ConnectionHttpService, ResponseResult } from '@softline/core';
import { MessageBarService } from '@softline/ui-core';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SOFTLINE_API_ESL_FLASH, SOFTLINE_API_ESL_FLASH_EXISTS } from './../esl.api';

@Injectable({ providedIn: 'root' })
export class EslLinkFlashService {
  constructor(private service: ConnectionHttpService) {}
  private messageBarService = inject(MessageBarService);
  private injector = inject(Injector);

  exists(idartstamm: number): Observable<string[]> {
    return this.service
      .get<ResponseResult<string[]>>({
        path: SOFTLINE_API_ESL_FLASH_EXISTS,
        pathParams: {
          idartstamm: idartstamm,
        },
      })
      .pipe(map((o) => o?.result ?? []));
  }

  flash(body: { idartstamm: number }[]): Observable<{ idartstamm: number }[]> {
    return this.service
      .create<
        typeof body,
        ResponseResult<typeof body>
      >({ path: SOFTLINE_API_ESL_FLASH }, body)
      .pipe(map((o) => o?.result ?? []));
  }

  async flashEsl(articelId: number) {
    if (!articelId) return;

    const body = [
      {
        idartstamm: articelId,
      },
    ];

    try {
      const result = await firstValueFrom(this.flash(body));

      if (result.find((o) => o.idartstamm === articelId)) {
        this.messageBarService.success('Verknüpfte ESL werden in Kürze blinken/leuchten');
      } else {
        this.messageBarService.warning(
          'Es wurden keine verknüpften ESL zu diesem Artikel gefunden'
        );
      }
    } catch (e) {
      handleRequestError(e, this.injector, { show: true });
    }
  }
}
